import React, { useState } from 'react';
import styled from 'styled-components';
import { Crown, CreditCard } from 'lucide-react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { authHeader, getToken } from '../auth';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 2rem 1rem 4rem;
`;

const Container = styled.div`
  max-width: 980px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.75rem;
`;

const Subtitle = styled.p`
  color: #4b5563;
  font-size: 1rem;
  max-width: 640px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: 1rem;
`;

const Badge = styled.div`
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #ffffff;
  font-weight: 700;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  font-size: 0.85rem;
`;

const Price = styled.div`
  font-size: 2.4rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.2rem;
`;

const PriceNote = styled.div`
  color: #6b7280;
  font-size: 0.95rem;
  margin-bottom: 1.4rem;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
  display: grid;
  gap: 0.6rem;
`;

const FeatureItem = styled.li`
  color: #374151;
  font-size: 0.95rem;
`;

const MessageBox = styled.div`
  background: #f8fafc;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  padding: 1.25rem;
  margin-top: 1.5rem;
  display: grid;
  gap: 0.5rem;
`;

const MessageRow = styled.div`
  font-size: 0.95rem;
  color: #1f2937;
`;

const CTAButton = styled.button`
  margin-top: 1.75rem;
  width: 100%;
  border: none;
  border-radius: 999px;
  padding: 0.9rem 1.2rem;
  font-size: 1rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
`;

const PremiumPass = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = getToken();

  const handleBuy = async () => {
    if (!token) {
      toast.error('Premium Pass almak için önce giriş yapmalısın.');
      navigate('/login');
      return;
    }

    setLoading(true);
    try {
      const res = await api.post(
        '/api/payment/lemonsqueezy/init',
        {},
        { headers: authHeader() }
      );
      const checkoutUrl = res.data?.checkoutUrl;
      if (!checkoutUrl) {
        toast.error('ödeme sayfası alınamadı.');
        return;
      }
      window.location.href = checkoutUrl;
    } catch (err) {
      toast.error(err.response?.data?.error || 'Ödeme başlatılamadı.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer>
      <Container>
        <Header>
          <Title>30 Gün Premium Pass</Title>
          <Subtitle>
            Premium özelliklere tek seferlik ödemeyle erişebilirsin. Abonelik yok, otomatik yenileme yok.
          </Subtitle>
        </Header>

        <Card>
          <CardHeader>
            <Crown size={28} color="#6366f1" />
            <div>
              <div style={{ fontWeight: 700, fontSize: '1.2rem', color: '#111827' }}>
                30 Gün Premium Pass
              </div>
              <Badge>Tek seferlik ödeme</Badge>
            </div>
          </CardHeader>

          <Price>93.99 TL</Price>
          <PriceNote>Tek seferlik ödeme</PriceNote>

          <FeatureList>
            <FeatureItem> Tüm CV araçları sınırsız</FeatureItem>
            <FeatureItem> Mülakat simülasyonu</FeatureItem>
            <FeatureItem> ATS detaylı analiz</FeatureItem>
            <FeatureItem> PDF indirme</FeatureItem>
            <FeatureItem>Abonelik yok</FeatureItem>
            <FeatureItem>Otomatik yenileme yok</FeatureItem>
          </FeatureList>

          <MessageBox>
            <MessageRow>30 gün boyunca tüm araçlar sınırsız</MessageRow>
            <MessageRow>Otomatik yenileme yok</MessageRow>
            <MessageRow>Abonelik yok</MessageRow>
            <MessageRow>Eğer istersen süresi bitince tekrar satın alabilirsin</MessageRow>
          </MessageBox>

          <CTAButton type="button" onClick={handleBuy} disabled={loading}>
            <CreditCard size={18} />
            {loading ? 'Ödeme başlatılıyor...' : 'Satın Al'}
          </CTAButton>
        </Card>
      </Container>
    </PageContainer>
  );
};

export default PremiumPass;
